/* eslint-disable max-params, no-param-reassign -- these linting errors come up constantly with reducers */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import { useAppDispatch, useAppSelector } from "@/store/hooks";

type LoginSliceState = {
  email: string;
};

const initialState: LoginSliceState = {
  email: "",
};

const loginSlice = createSlice({
  // NOTE: extraReducers is explicitly omitted for the loginSlice,
  // as extraReducers is used to reset the entire redux store on logout
  // however, we do not want to reset the login redux store, as the saved email value
  // is used for "Remember me" login pre-filling
  initialState,
  name: "login",
  reducers: {
    resetLoginState: () => initialState,
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
  },
});

const { resetLoginState: resetLoginStateAction, setEmail: setEmailAction } =
  loginSlice.actions;

const useLoginSelector = () => {
  return useAppSelector((state) => state.login);
};

const useLoginDispatch = () => {
  const dispatch = useAppDispatch();

  const setEmail = (email: string) => {
    dispatch(setEmailAction(email));
  };

  const resetLoginState = () => {
    dispatch(resetLoginStateAction());
  };

  return {
    resetLoginState,
    setEmail,
  };
};

export { useLoginDispatch, useLoginSelector };
export default loginSlice.reducer;
